import React from "react";

const Footer = () => (
  <footer className="global-footer typ-footnote"> 
    
      <div className="global-footer__left">
          {/* <p className="clr-secondary-text">
              A 2024 Curator Creation. All rights reserved.
          </p>
          <p className="clr-secondary-text">
              This website is built to better find what movie to watch next. Non-commercial use only. Much of the movie data is from IMDb data and publicly accessable via a googgle search. Much of the design is influences by the Apple TV website. Many thanks to all those who have created before us and to those who will create after us. If you have any suggestions for improvement, please let us know. Happy watching!
          </p> */}

          <p className="clr-secondary-text">
            This site is created for educational purposes and is not affiliated with IMDb, Apple TV, or any other services mentioned herein. All trademarks and copyrights belong to their respective owners. Movie data sourced from TMDB and watch provider data attributed to JustWatch.
          </p><br />
          <p className="clr-secondary-text">
            The content on this website, including movie data and design elements, is gathered and synthesized from publicly available sources and is intended for personal and non-commercial use only. The design is inspired by the exemplary user experience of the Apple TV website, and we strive to pay homage to their innovation while providing a unique service for our users.
          </p><br />
          <p className="clr-secondary-text">
            We are grateful to the creators and developers whose resources have contributed to this educational project. Our goal is to assist users in discovering movies to watch next, enhancing their viewing experience. For feedback or suggestions, please reach out to us. Enjoy exploring movies with Curator!
          </p>

          <p className="clr-primary-text global-footer__links">
              <a data-link-to-exclude="" className="global-footer__links__link" href="/newsroom">
                  Newsroom
              </a>
              <a data-link-to-exclude="" className="global-footer__links__link" href="/contact">
                  Contact
              </a>
              <a data-link-to-exclude="" className="global-footer__links__link" href="/privacy">
                  Privacy Policy
              </a>
          </p>
      </div>
    
    {/* <div className="logo" /> */}
    {/* <p>
      Sample project provided by <a href="https://auth0.com">Auth0</a>
    </p> */}
    
  </footer>
);

export default Footer;
